import { scrollAnimataion } from './scroll-animataion/scroll-animataion.js';
import { markerSet } from './marker-set/marker-set.js';
import { fadeJudge } from './to-top-btn-fade/to-top-btn-fade.js';


// ===========================================
// 中見出しのインタラクション
// ===========================================
$(function () {
  markerSet( $('.campaign') );

  $(window).on('scroll', function(){
    markerSet( $('.campaign') );
  });
});


// ===========================================
// スクロールアニメーションのオプション
// ===========================================
scrollAnimataion({
  className: "beyondArea",
  triggerPoint: 200,
});


// ===========================================
// ソートナビのインタラクション
// ===========================================
$(function () {
  function allCheckJudge( btn, allCheck ) {
    let allCheckTrue = true,
        allCheckFalse = true;

    btn.each(function(){
      if( $(this).prop('checked') === false ) {
        allCheckTrue = false;
      } else {
        allCheckFalse = false;
      }
    });

    if( allCheckTrue === true || allCheckFalse === true ) {
      allCheck.prop('checked', true);
    } else {
      allCheck.prop('checked', false);
    }
  }

  $('.campaignListArea').each(function(){
    const area = $(this),
          btn = area.find('input[name="campaign"]').not('input[name="campaign"]#all'),
          allCheck = area.find('input[name="campaign"]#all');

    allCheckJudge( btn, allCheck )

    btn.on('change', function(){
      allCheckJudge( btn, allCheck );
    });
  });
});


// ===========================================
// 終了したキャンペーンを末尾に配置
// ===========================================
/*$(function () {
  $('.campaignList__item').each(function(){
    const item = $(this),
          list = item.parent(),
          today = new Date(Date.now()),
          eventDay = new Date( item.attr('data-date') ),
          itemClass = item.attr('class'),
          itemCat = item.attr('data-cat'),
          itemDate = item.attr('data-date'),
          itemHtml = item.html();

    if( today > eventDay ) {
      list.append(
        '<li ' +
          'class="' + itemClass + ' ' + itemClass + '--end"' +
          'data-cat="' + itemCat + '"' +
          'data-date="' + itemDate + '"' +
        '>' + itemHtml + '</li>'
      );
      item.remove();
    }
  });
});*/


// ===========================================
// ページ上部へ戻るボタンのインタラクション
// ===========================================
$(function () {
  fadeJudge();
});